/* BodyStop (31 Oct 2026): on Add to cart the product photo flies into the cart icon, the icon bounces and the
   cart count goes up. The cart drawer does NOT open after an add; it opens only when the shopper taps the cart.
   On product tiles the photo ALWAYS starts from the tile's own picture (held inside the screen if the picture is
   partly scrolled away), so it looks the same every time.
   The photo re-checks its target on every frame, so scrolling during the flight is fine:
     - a header / sticky-header / bottom-bar cart icon on screen -> the photo flies there
     - no cart icon on screen -> a small round cart with the count appears top-right and the photo flies there
   The round cart hides the moment a header cart comes back on screen, so there are never two carts showing,
   and hides by itself ~3.5 s after the add.
   The flight is skipped for visitors who have "reduce motion" switched on. Loaded once from layout/theme.liquid. */
(function () {
  if (window.__bsFlyToCart) return;
  window.__bsFlyToCart = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 700;
  var flight = null;
  var suppressUntil = 0;
  var floatCart = null;
  var floatTimer = null;
  var floatWatch = null;
  var BAG = '<svg aria-hidden="true" focusable="false" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M352 128C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128H0v304c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V128h-96zM224 48c44.112 0 80 35.888 80 80H144c0-44.112 35.888-80 80-80zm176 384c0 17.645-14.355 32-32 32H80c-17.645 0-32-14.355-32-32V176h48v40c0 13.255 10.745 24 24 24s24-10.745 24-24v-40h160v40c0 13.255 10.745 24 24 24s24-10.745 24-24v-40h48v256z"/></svg>';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function clamp(v, lo, hi) {
    return Math.max(lo, Math.min(hi, v));
  }

  // How many square pixels of this box are on screen
  function visibleArea(r) {
    var w = Math.min(r.right, window.innerWidth) - Math.max(r.left, 0);
    var h = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
    return w > 0 && h > 0 ? w * h : 0;
  }

  // A theme cart icon (header, sticky header or phone bottom bar) whose centre is on screen
  function iconOnScreen() {
    var icons = document.querySelectorAll('.m-cart-icon-bubble');
    for (var i = 0; i < icons.length; i++) {
      var r = icons[i].getBoundingClientRect();
      var cx = r.left + r.width / 2;
      var cy = r.top + r.height / 2;
      if (r.width > 0 && cx > 0 && cx < window.innerWidth && cy > 10 && cy < window.innerHeight - 10) return icons[i];
    }
    return null;
  }

  function currentCount() {
    var b = document.querySelector('.m-cart-count-bubble');
    var n = b ? parseInt(b.textContent, 10) : 0;
    return isNaN(n) ? 0 : n;
  }

  // ---- Small round cart (only while no theme cart icon is on screen) ----
  function isFloatVisible() {
    return !!floatCart && floatCart.classList.contains('is-visible');
  }
  function showFloatCart() {
    if (!floatCart) {
      floatCart = document.createElement('button');
      floatCart.type = 'button';
      floatCart.className = 'bs-float-cart';
      floatCart.setAttribute('aria-label', 'View cart');
      floatCart.innerHTML = BAG + '<span class="bs-float-cart__count"></span>';
      floatCart.addEventListener('click', function () {
        suppressUntil = 0;
        hideFloatCart();
        var d = document.querySelector('m-cart-drawer');
        if (d && typeof d.open === 'function') d.open();
        else window.location.href = root() + 'cart';
      });
      document.body.appendChild(floatCart);
    }
    if (!isFloatVisible()) {
      floatCart.querySelector('.bs-float-cart__count').textContent = currentCount();
      floatCart.classList.add('is-visible');
      // Hide it the moment a theme cart icon comes back on screen (e.g. sticky header on scroll up)
      clearInterval(floatWatch);
      floatWatch = setInterval(function () {
        if (iconOnScreen()) hideFloatCart();
      }, 120);
    }
    return floatCart;
  }
  function hideFloatCart() {
    clearTimeout(floatTimer);
    clearInterval(floatWatch);
    floatWatch = null;
    if (floatCart) floatCart.classList.remove('is-visible');
  }
  function hideFloatCartSoon() {
    clearTimeout(floatTimer);
    floatTimer = setTimeout(hideFloatCart, 3500);
  }

  // Where the photo should go right now. Called on every frame of the flight.
  function targetNow() {
    var icon = iconOnScreen();
    if (icon) {
      if (isFloatVisible()) hideFloatCart();
      var r = icon.getBoundingClientRect();
      return { el: icon, x: r.left + r.width / 2, y: r.top + r.height / 2 };
    }
    var f = showFloatCart();
    var fr = f.getBoundingClientRect();
    return { el: f, x: fr.left + fr.width / 2, y: fr.top + fr.height / 2 };
  }

  // ---- Cart count ----
  function updateCount() {
    fetch(root() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        document.querySelectorAll('.m-cart-count-bubble').forEach(function (b) {
          if (n > 0) { b.textContent = n; b.classList.remove('m:hidden'); }
          else b.classList.add('m:hidden');
        });
        if (floatCart) floatCart.querySelector('.bs-float-cart__count').textContent = n;
      })
      .catch(function () {});
  }

  // ---- Where the flying photo starts ----
  // Returns { src, size, x, y } or null
  function startPoint(btn) {
    var card = btn.closest('.m-product-card');
    if (card) {
      // Product tile: ALWAYS from the tile's own picture.
      var ci = card.querySelector('.m-product-card__main-image img') || card.querySelector('img');
      if (!ci) return null;
      var cr = ci.getBoundingClientRect();
      var cs = Math.min(cr.width, cr.height, 160);
      if (!(cs > 10)) cs = 64;
      return {
        src: ci.currentSrc || ci.src,
        size: cs,
        x: clamp(cr.left + cr.width / 2, cs / 2, window.innerWidth - cs / 2),
        // if part of the picture is scrolled away, start from the edge of the screen nearest to it
        y: clamp(cr.top + cr.height / 2, cs / 2 + 4, window.innerHeight - cs / 2 - 4)
      };
    }
    // Product page / quick view: the gallery photo that is most visible right now
    var scope = btn.closest('.m-main-product, .m-product-quickview, [data-section-type="product"], section') || document;
    var imgs = scope.querySelectorAll('.m-product-media img');
    if (!imgs.length) imgs = scope.querySelectorAll('img');
    var best = null, bestArea = 0;
    for (var i = 0; i < imgs.length; i++) {
      var a = visibleArea(imgs[i].getBoundingClientRect());
      if (a > bestArea) { best = imgs[i]; bestArea = a; }
    }
    if (best && bestArea > 2500) {
      var ir = best.getBoundingClientRect();
      var l = Math.max(ir.left, 0), r = Math.min(ir.right, window.innerWidth);
      var t = Math.max(ir.top, 0), b = Math.min(ir.bottom, window.innerHeight);
      return { src: best.currentSrc || best.src, size: Math.min(r - l, b - t, 160), x: (l + r) / 2, y: (t + b) / 2 };
    }
    // Gallery scrolled away (sticky Add to cart bar): the main pack photo, flying from the button
    var fallback = scope.querySelector('.swiper-slide-active .m-product-media img, .swiper-slide-active img') || imgs[0] || null;
    if (!fallback) return null;
    var br = btn.getBoundingClientRect();
    return { src: fallback.currentSrc || fallback.src, size: 64, x: br.left + br.width / 2, y: br.top + br.height / 2 };
  }

  function cancelFlight() {
    if (flight) {
      cancelAnimationFrame(flight.raf);
      if (flight.el) flight.el.remove();
    }
    flight = null;
  }

  function land(f, targetEl) {
    if (targetEl && targetEl.animate) {
      targetEl.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(.94)' }, { transform: 'scale(1)' }],
        { duration: 420, easing: 'ease-out' }
      );
    }
    if (targetEl === floatCart) hideFloatCartSoon();
    var el = f.el;
    var fade = el.animate ? el.animate([{ opacity: el.style.opacity || 1 }, { opacity: 0 }], { duration: 120, fill: 'forwards' }) : null;
    var done = function () {
      el.remove();
      if (flight === f) flight = null;
    };
    if (fade) fade.onfinish = done; else done();
  }

  function fly(btn) {
    var sp = startPoint(btn);
    if (!sp || !sp.src) return;
    var size = sp.size > 10 ? sp.size : 64;
    var sx = sp.x, sy = sp.y;
    var endScale = 26 / size;

    cancelFlight();

    var el = document.createElement('div');
    el.setAttribute('aria-hidden', 'true');
    el.className = 'bs-fly';
    el.style.cssText = 'position:fixed;left:' + (sx - size / 2) + 'px;top:' + (sy - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px;z-index:2147483000;pointer-events:none;will-change:transform,opacity';
    var pic = new Image();
    pic.alt = '';
    pic.src = sp.src;
    pic.style.cssText = 'display:block;width:100%;height:100%;object-fit:cover;border-radius:50%;background:#fff;border:2px solid #fff;box-shadow:0 6px 18px rgba(21,55,10,.3)';
    el.appendChild(pic);
    document.body.appendChild(el);

    var f = { el: el, raf: 0 };
    flight = f;
    var t0 = performance.now();

    function step(now) {
      if (flight !== f) return;
      var p = Math.min(1, (now - t0) / DURATION);
      var tgt = targetNow(); // re-aimed every frame, so scrolling mid-flight is followed
      // sideways starts slow, vertical starts fast: together they draw a curve
      var ex = p * p * (0.4 + 0.6 * p);
      var ey = 1 - Math.pow(1 - p, 2.2);
      var x = (tgt.x - sx) * ex;
      var y = (tgt.y - sy) * ey;
      var s = 1 + (endScale - 1) * (1 - Math.pow(1 - p, 1.6));
      el.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + s + ')';
      el.style.opacity = p > 0.85 ? String(1 - (p - 0.85)) : '1';
      if (p < 1) f.raf = requestAnimationFrame(step);
      else land(f, tgt.el);
    }
    f.raf = requestAnimationFrame(step);
  }

  // ---- Clicks ----
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    // Shopper taps a cart: let the drawer open normally
    if (e.target.closest('.m-cart-icon-bubble')) {
      suppressUntil = 0;
      hideFloatCart();
      return;
    }

    var btn = e.target.closest('button[name="add"]');
    if (!btn || btn.disabled || btn.classList.contains('disabled')) return;
    if (!btn.closest('product-form')) return;

    // An add is starting: keep the cart drawer closed
    suppressUntil = performance.now() + 6000;

    if (reduceMotion) {
      if (!iconOnScreen()) { showFloatCart(); hideFloatCartSoon(); }
      return;
    }
    try { fly(btn); } catch (err) {}
  }, true);

  // ---- Keep the drawer closed after an add ----
  function patchDrawer() {
    var Drawer = window.customElements.get('m-cart-drawer');
    if (!Drawer || Drawer.prototype.__bsFlyPatched) return;
    var originalOpen = Drawer.prototype.open;
    Drawer.prototype.open = function () {
      if (performance.now() < suppressUntil) return;
      return originalOpen.apply(this, arguments);
    };
    Drawer.prototype.__bsFlyPatched = true;
  }
  if (window.customElements) window.customElements.whenDefined('m-cart-drawer').then(patchDrawer);

  // ---- Theme events ----
  function hookEvents() {
    try {
      window.MinimogEvents.subscribe('cart-update', function () {
        if (suppressUntil) {
          // stay closed a little longer for anything that reacts to the add (e.g. the free-gift script)
          suppressUntil = performance.now() + 2500;
        }
        updateCount();
        setTimeout(updateCount, 1500);
        if (isFloatVisible() && !flight) hideFloatCartSoon();
      });
      window.MinimogEvents.subscribe('cart-error', function () {
        suppressUntil = 0;
        cancelFlight();
        hideFloatCart();
      });
    } catch (e) {}
  }
  if (window.MinimogEvents) hookEvents();
  else document.addEventListener('DOMContentLoaded', hookEvents);
})();
